import React from 'react'
import {Stack, Typography} from '@mui/material'
import {useNavigate} from 'react-router-dom'

import SettingsMenu from 'components/UserNavMenu/SettingsMenu'
import Wallet from 'components/UserNavMenu/WalletMenu'
import {colors} from '@/constants'
import {UserInterface} from '@/types/types'
import {SET_IS_NEED_AUTH} from '@/store/slices'
import {useAppDispatch} from '@/hooks/redux'
import Notifications from '@/components/UserNavMenu/Notifications'
import TransCustom from '@/components/UI/i18next'

interface UserNavMenuProps {
  user: UserInterface | null
}

const Index = ({user}: UserNavMenuProps) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="flex-end"
      marginLeft="20px"
      flex="1"
      gap="15px">
      {!user && (
        <Stack style={{textWrap: 'nowrap'}} direction="row" gap="5px">
          <TransCustom
            className="pointer text-hover"
            color={colors.white}
            onClick={() => {
              dispatch(SET_IS_NEED_AUTH('AUTH'))
              navigate('/')
            }}
            i18nKey="1005"
          />

          <Typography fontSize="20px" color={colors.white}>
            /
          </Typography>
          <TransCustom
            className="pointer text-hover"
            color={colors.white}
            onClick={() => {
              dispatch(SET_IS_NEED_AUTH('REGISTER'))
              navigate('/')
            }}
            i18nKey="1006"
          />
        </Stack>
      )}
      {user && <Notifications user={user} />}
      {user && <Wallet user={user} />}
      {user && <SettingsMenu />}
    </Stack>
  )
}

export default Index
